import * as tslib_1 from "tslib";
import { ShadingMethodBase } from "./ShadingMethodBase";
/**
 * EffectFogMethod provides a method to add distance-based fog to a material.
 */
var EffectFogMethod = (function (_super) {
    tslib_1.__extends(EffectFogMethod, _super);
    /**
     * Creates a new EffectFogMethod object.
     * @param minDistance The distance from which the fog starts appearing.
     * @param maxDistance The distance at which the fog is densest.
     * @param fogColor The colour of the fog.
     */
    function EffectFogMethod(minDistance, maxDistance, fogColor) {
        if (minDistance === void 0) { minDistance = 0; }
        if (maxDistance === void 0) { maxDistance = 1000; }
        if (fogColor === void 0) { fogColor = 0x808080; }
        var _this = _super.call(this) || this;
        _this._minDistance = minDistance;
        _this._maxDistance = maxDistance;
        _this._fogColor = fogColor;
        return _this;
    }
    Object.defineProperty(EffectFogMethod.prototype, "assetType", {
        /**
         * @inheritDoc
         */
        get: function () {
            return EffectFogMethod.assetType;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EffectFogMethod.prototype, "minDistance", {
        /**
         * The distance from which the fog starts appearing.
         */
        get: function () {
            return this._minDistance;
        },
        set: function (value) {
            this._minDistance = value;
            this.invalidate();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EffectFogMethod.prototype, "maxDistance", {
        /**
         * The distance at which the fog is densest.
         */
        get: function () {
            return this._maxDistance;
        },
        set: function (value) {
            this._maxDistance = value;
            this.invalidate();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EffectFogMethod.prototype, "fogColor", {
        /**
         * The colour of the fog.
         */
        get: function () {
            return this._fogColor;
        },
        set: function (value) {
            this._fogColor = value;
            this.invalidate();
        },
        enumerable: true,
        configurable: true
    });
    return EffectFogMethod;
}(ShadingMethodBase));
export { EffectFogMethod };
EffectFogMethod.assetType = "[asset EffectFogMethod]";



// WEBPACK FOOTER //
// ../dist/lib/methods/EffectFogMethod.js